import { __rest } from '../../node_modules/tslib/tslib.es6.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { Wrapper } from './loading.style.js';

const Loading = props => {
    const { backgroundColor = 'primary', className = '', id = '', margin, color } = props, rest = __rest(props, ["backgroundColor", "className", "id", "margin", "color"]);
    return (jsxs(Wrapper, Object.assign({ className: className, "data-testid": "loading", id: id, margin: margin, backgroundColor: backgroundColor, color: color }, rest, { children: [jsx("div", {}, void 0), jsx("div", {}, void 0), jsx("div", {}, void 0)] }), void 0));
};

export { Loading };
